module.exports = __webpack_public_path__ + "img/cat-3.af87d949.svg";